import { t } from 'ttag'
import en from 'i18n/job_profile_skills.en.json'
import nb from 'i18n/job_profile_skills.nb.json'

type Skill = {
  label: string
  description: string
  explanation: string[]
  category: string
}

type SkillText = [
  label: string,
  description: string,
  explanation: string[],
  category: string,
]

const languages: Record<string, Record<string, Skill>> = { en, nb }

// Object.entries throws for an unknown language, as R.map did
export const categoryNames = (language = 'en'): Record<string, SkillText> =>
  Object.fromEntries(
    Object.entries(languages[language]).map(
      ([name, { label, description, explanation, category }]) => [
        name,
        [label, description, explanation, category],
      ],
    ),
  )

export const variableNames = () => ({
  productivity: [
    t`high productivity`,
    t`Is high productivity an important goal for your organization? By prioritizing high productivity, the algorithm will adjust the evaluation of factors important for high productivity. For example, a candidate’s ability to work structured will be crucial.`,
  ],
  sicknessAbsence: [
    t`low sickness absence`,
    t`Does your organization have a goal to reduce sickness absence? By prioritizing low sickness absence, the algorithm will adjust the evaluation of factors important for low sickness absence.`,
  ],
  turnover: [
    t`low turnover`,
    t`Securing employees who stay in the workforce longer is important to many organizations. By prioritizing low turnover, the algorithm will adjust the evaluation of factors important for low turnover.`,
  ],
  // wage: [t`wage pressure`, t`will not ask for a high salary`],
})
